import { ILog } from "../../Types"
import { createViewData } from "../../App/ViewData"
import { FocusViewState } from "./Context"
import { FocusWriters } from "./writers"

// The data-acquisition layer's assembled value for FocusView's presentational
// component (`FocusViewUI`), read via `useFocusData()`. The frame's records, logs and
// statuses all come from the shared store; only current-day selection is view-local.
export interface FocusDataViewData {
  // The loaded/derived current-day frame (cruise + trip + days + today's logs/statuses),
  // or `undefined` while still loading. `FocusViewUI` renders a Loading placeholder until
  // it (and its cruise/trip) are present.
  currentState: FocusViewState | undefined;
  // The live "now" entry (the id-0 current log) driving the entry surface and advices,
  // read from the centralized store's `CurrentLog` slice.
  currentLog: ILog | undefined;
  // Whether the current user may record into the current log (gates the LogView write
  // callbacks).
  editable: boolean;
  // The write surface the current-log entry UI calls (the four `current/*` endpoints),
  // using store-backed optimistic writers (the id-0 create-commit via DataStore.mutate).
  writers: FocusWriters;
}

export const { Context: FocusDataContext, useData: useFocusData } = createViewData<FocusDataViewData>("FocusDataView");
